import {
  Typography,
  Card,
  CardContent,
  CardHeader,
  Paper,
  Avatar,
  Box,
  Grid,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useState, useEffect, useContext } from "react";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import Helper from "../../common/Helper";
import { baseUrl } from "../../services/AzureStorage";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../common/RouteConstants";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "5px 15px",
    border: "1px solid lightgrey",
    borderRadius: "10px",
    boxShadow: "2px 2px 11px grey inset",
  },
  listItemIcon: {
    minWidth: "38px",
  },
  imageIcon: {
    width: "100%",
    height: "100%",
    cursor: "pointer",
  },
  iconRoot: {
    textAlign: "center",
    width: "100%",
    height: "50px",
  },
  smBlue: {
    marginLeft: "8px",
    width: 26,
    height: 26,
    color: "#222222",
    backgroundColor: "#acb9d1",
    position: "relative",
    overflow: "hidden",
    borderRadius: "50%",
  },

  cardStyle: {
    border: "1px solid lightgrey",
    borderRadius: "10px",
    minHeight: "292px",
    "& .MuiCardContent-root": {
      padding: theme.spacing(0.75),
      height: "calc(292px - 48px)",
      background: "#f7f7f7",
      "& .MuiPaper-root": {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "space-between",
      },
    },
  },
  cardHeader: {
    padding: theme.spacing(1.5, 2.5),
    color: "#171717",
    borderLeft: "6px solid #1d428a",
    "& .MuiTypography-root": {
      fontWeight: "600",
    },
  },
  tableRow: {
    // '&:nth-child(even)':{
    "&:nth-child(odd)": {
      background: "#f5f5f5",
    },
    "& .MuiTableCell-root": {
      borderBottom: "none",
    },

    // boxShadow: "0px 1px 2px 0px rgba(0,0,0,0.5)",
    //background: "#F8EEE8",
  },
  backgroundAntros: {
    background: "#c1d0ed",
    border: "none",

    // background: "#b9e4d8",
    // border: "2px solid #309578",

    //background: "linear-gradient(#00ffff, #66ffcc)",
  },
  backgroundStrAndAgility: {
    background: "#c1d0ed",
    border: "none",

    // background: "#e4bac1",
    // border: "2px solid #a42439",
  },
  backgroundShooting: {
    background: "#c1d0ed",
    border: "none",
  },
  playerNameStyle: {
    cursor: "pointer",
    "&:hover": {
      color: "blue",
    },
  },
}));

export default function DashboardCard(props) {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  let navigate = useNavigate();
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const within = (val) => {
    if (
      val == 101 ||
      val == 102 ||
      val == 103 ||
      val == 104 ||
      val == 105 ||
      val == 106 ||
      val == 107 ||
      val == 108
    ) {
      return 0;
    } else if (
      val == 2010 ||
      val == 2011 ||
      val == 202 ||
      val == 203 ||
      val == 204 ||
      val == 205 ||
      val == 206
    ) {
      return 1;
    } else if (
      val == 301 ||
      val == 302 ||
      val == 303 ||
      val == 304 ||
      val == 305 ||
      val == 306 ||
      val == 307
    ) {
      return 2;
    }
  };

  const viewPlayerProfile = (playerId, playerName) => {
    if (props.isWebView) {
      return sendNavigation("PLAYER_DETAILS", { UserName: playerName });
    }

    navigate(
      `/${props.eventId}${RouteConstants.VIEW_PLAYER_PROFILE}/${playerId}`,
      {
        state: {
          from: props.from,
          tab: "tab" in props ? props.tab : "",
        },
      }
    );
  };

  const sendNavigation = (screenName, params) => {
    window.ReactNativeWebView?.postMessage(
      JSON.stringify({ action: "NAVIGATE", screen: screenName, params })
    );
  };

  return (
    <>
      {props.data.active && (
        <Grid item lg={3} xs={12} md={4}>
          <Card
            className={`${classes.cardStyle} ${
              within(props.value) == 0
                ? classes.backgroundAntros
                : within(props.value) == 1
                ? classes.backgroundStrAndAgility
                : classes.backgroundShooting
            }`}
          >
            <CardHeader
              title={
                <>
                  {props.value != 102 ? (
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      pr={2}
                    >
                      <Typography
                        component="span"
                        variant="body1"
                        style={{ color: "#1d428a" }}
                      >
                        {props.title}
                      </Typography>
                      <Typography
                        component="span"
                        variant="body1"
                        style={{ color: "#1d428a", fontSize: "13px" }}
                      >
                        &nbsp;&nbsp;{props.unit}
                      </Typography>
                    </Box>
                  ) : (
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Typography
                        component="span"
                        variant="body1"
                        style={{ color: "#1d428a" }}
                      >
                        {props.title}
                      </Typography>
                      <Typography
                        component="span"
                        variant="body1"
                        style={{ color: "#1d428a", fontSize: "13px" }}
                      >
                        &nbsp;&nbsp;{props.unit}
                      </Typography>
                    </Box>
                  )}
                </>
              }
              // titleTypographyProps={{
              //   component: "span",
              //   variant: "h6",
              //   color: "primary",
              // }}
              className={classes.cardHeader}
              sx={{ padding: "12px 16px !important" }}
            />
            <CardContent>
              <Paper
                elevation={0}
                sx={{ width: "100%", borderRadius: "10px" }}
                //style={{ background: "linear-gradient(#00ffff, #66ffcc)" }}

                // className={
                //   within(props.value) == 0
                //     ? classes.backgroundAntros
                //     : within(props.value) == 1
                //     ? classes.backgroundStrAndAgility
                //     : classes.backgroundShooting
                // }
              >
                <TableContainer>
                  <Table>
                    <TableBody>
                      {props.data.data &&
                        Array.isArray(props.data.data) &&
                        props.data.data.length > 0 &&
                        props.data.data
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((row, index) => {
                            return (
                              <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                className={classes.tableRow}
                                key={row.playerID}
                              >
                                <TableCell
                                  width="80%"
                                  style={{ padding: "5px" }}
                                >
                                  <Box display="flex">
                                    <Box display="flex" alignItems="center">
                                      {row.headshotURL &&
                                      row.headshotURL != "" ? (
                                        <Avatar
                                          className={classes.smBlue}
                                          sx={{
                                            bgcolor: "#1d428a",
                                            cursor: "pointer",
                                          }}
                                          src={
                                            row.headshotURL
                                              ? baseUrl(row.headshotURL)
                                              : ""
                                          }
                                          alt="basketball"
                                          title="View Player Profile"
                                          onClick={() =>
                                            viewPlayerProfile(
                                              row.playerID,
                                              row.playerName
                                            )
                                          }
                                        >
                                          <Typography variant="caption">
                                            {Helper.GetNameInitials(
                                              `${row.playerName}`
                                            )}
                                          </Typography>
                                        </Avatar>
                                      ) : (
                                        <Avatar
                                          className={classes.smBlue}
                                          sx={{
                                            bgcolor: "#1d428a",
                                            cursor: "pointer",
                                          }}
                                          alt="basketball"
                                          title="View Player Profile"
                                          onClick={() =>
                                            viewPlayerProfile(
                                              row.playerID,
                                              row.playerName
                                            )
                                          }
                                        >
                                          <Typography variant="caption">
                                            {Helper.GetNameInitials(
                                              `${row.playerName}`
                                            )}
                                          </Typography>
                                        </Avatar>
                                      )}

                                      {/* <Avatar className={classes.smBlue}>
                                        <Typography variant="caption">
                                          {row.playerName &&
                                            Helper.GetNameInitials(
                                              `${row.playerName}`
                                            )}
                                        </Typography>
                                      </Avatar> */}
                                    </Box>
                                    <Box display="flex" alignItems="center">
                                      &nbsp;&nbsp;
                                      <Typography
                                        variant="body2"
                                        className={classes.playerNameStyle}
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(
                                            row.playerID,
                                            row.playerName
                                          )
                                        }
                                      >
                                        {row.playerName}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </TableCell>
                                {props.value == 101 && (
                                  <TableCell
                                    align="center"
                                    width="20%"
                                    style={{ padding: "5px" }}
                                  >
                                    {row.bodyFat}
                                  </TableCell>
                                )}
                                {props.value == 108 && (
                                  <TableCell
                                    align="center"
                                    width="20%"
                                    style={{ padding: "5px" }}
                                  >
                                    {row.bodyFatDXA}
                                  </TableCell>
                                )}
                                {props.value == 102 && (
                                  <TableCell
                                    align="center"
                                    width="20%"
                                    style={{ padding: "5px" }}
                                  >
                                    {props.getHandDimensionsUnitValue != null &&
                                    props.getHandDimensionsUnitValue !=
                                      undefined
                                      ? props.getHandDimensionsUnitValue(
                                          row.handWidth
                                        )
                                      : row.handWidth}
                                    &nbsp;|&nbsp;
                                    {props.getHandDimensionsUnitValue != null &&
                                    props.getHandDimensionsUnitValue !=
                                      undefined
                                      ? props.getHandDimensionsUnitValue(
                                          row.handLength
                                        )
                                      : row.handLength}
                                  </TableCell>
                                )}
                                {props.value == 103 && (
                                  <TableCell
                                    align="center"
                                    width="20%"
                                    style={{ padding: "5px" }}
                                  >
                                    {props.getWeightUnitValue != null &&
                                    props.getWeightUnitValue != undefined
                                      ? props.getWeightUnitValue(row.bodyWeight)
                                      : row.bodyWeight}
                                  </TableCell>
                                )}
                                {props.value == 104 && (
                                  <TableCell
                                    align="center"
                                    width="20%"
                                    style={{ padding: "5px" }}
                                  >
                                    {props.getLengthUnitValue != null &&
                                    props.getLengthUnitValue != undefined
                                      ? props.getLengthUnitValue(
                                          row.heightWithShoesFeet,
                                          row.heightWithShoesInches
                                        )
                                      : `${row.heightWithShoesFeet}' ${row.heightWithShoesInches}"`}
                                  </TableCell>
                                )}
                                {props.value == 105 && (
                                  <TableCell
                                    align="center"
                                    width="20%"
                                    style={{ padding: "5px" }}
                                  >
                                    {props.getLengthUnitValue != null &&
                                    props.getLengthUnitValue != undefined
                                      ? props.getLengthUnitValue(
                                          row.heightWithOutShoesFeet,
                                          row.heightWithOutShoesInches
                                        )
                                      : `${row.heightWithOutShoesFeet}' ${row.heightWithOutShoesInches}"`}
                                  </TableCell>
                                )}
                                {props.value == 106 && (
                                  <TableCell
                                    align="center"
                                    width="20%"
                                    style={{ padding: "5px" }}
                                  >
                                    {props.getLengthUnitValue != null &&
                                    props.getLengthUnitValue != undefined
                                      ? props.getLengthUnitValue(
                                          row.standingReachFeet,
                                          row.standingReachInches
                                        )
                                      : `${row.standingReachFeet}' ${row.standingReachInches}"`}
                                  </TableCell>
                                )}
                                {props.value == 107 && (
                                  <TableCell
                                    align="center"
                                    width="20%"
                                    style={{ padding: "5px" }}
                                  >
                                    {props.getLengthUnitValue != null &&
                                    props.getLengthUnitValue != undefined
                                      ? props.getLengthUnitValue(
                                          row.wingSpanFeet,
                                          row.wingSpanInches
                                        )
                                      : `${row.wingSpanFeet}' ${row.wingSpanInches}"`}
                                  </TableCell>
                                )}

                                {props.value == 2010 && (
                                  <TableCell
                                    align="center"
                                    width="20%"
                                    style={{ padding: "5px" }}
                                  >
                                    {row.shuttleRunLeftTrialTime}
                                  </TableCell>
                                )}
                                {props.value == 20121 && (
                                  <TableCell
                                    align="center"
                                    width="20%"
                                    style={{ padding: "5px" }}
                                  >
                                    {row.shuttleRunLeftLaserTime}
                                  </TableCell>
                                )}
                                {props.value == 2011 && (
                                  <TableCell
                                    align="center"
                                    width="20%"
                                    style={{ padding: "5px" }}
                                  >
                                    {row.shuttleRunRightTrialTime}
                                  </TableCell>
                                )}
                                {props.value == 20120 && (
                                  <TableCell
                                    align="center"
                                    width="20%"
                                    style={{ padding: "5px" }}
                                  >
                                    {row.shuttleRunRightLaserTime}
                                  </TableCell>
                                )}
                                {props.value == 202 && (
                                  <TableCell
                                    align="center"
                                    width="20%"
                                    style={{ padding: "5px" }}
                                  >
                                    {row.threeFourRunTime}
                                  </TableCell>
                                )}
                                {props.value == 20222 && (
                                  <TableCell
                                    align="center"
                                    width="20%"
                                    style={{ padding: "5px" }}
                                  >
                                    {row.threeFourRunTotalLaserTime}
                                  </TableCell>
                                )}
                                {props.value == 203 && (
                                  <TableCell
                                    align="center"
                                    width="20%"
                                    style={{ padding: "5px" }}
                                  >
                                    {row.proLaneTrialTime}
                                  </TableCell>
                                )}
                                {props.value == 20323 && (
                                  <TableCell
                                    align="center"
                                    width="20%"
                                    style={{ padding: "5px" }}
                                  >
                                    {row.proLaneTotalLaserTime}
                                  </TableCell>
                                )}
                                {props.value == 204 && (
                                  <TableCell
                                    align="center"
                                    width="20%"
                                    style={{ padding: "5px" }}
                                  >
                                    {/* {row.maxVerticalFeet}'.
                                    {row.maxVerticalInches}" */}
                                    {props.getHandDimensionsUnitValue(
                                      row.maxVerticalLeap
                                    )}
                                  </TableCell>
                                )}
                                {props.value == 205 && (
                                  <TableCell
                                    align="center"
                                    width="20%"
                                    style={{ padding: "5px" }}
                                  >
                                    {/* {row.standingVerticalFeet}'.
                                    {row.standingVerticalInches}" */}
                                    {props.getHandDimensionsUnitValue(
                                      row.standingVerticalLeap
                                    )}
                                  </TableCell>
                                )}
                                {within(props.value) == 2 && (
                                  <TableCell
                                    align="center"
                                    width="20%"
                                    style={{ padding: "5px" }}
                                  >
                                    {row.noOfMade}/{row.maxCount}
                                  </TableCell>
                                )}
                              </TableRow>
                            );
                          })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[5]}
                  component="div"
                  count={
                    props.data.data && props.data.data.length > 0
                      ? props.data.data.length
                      : 0
                  }
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            </CardContent>
          </Card>
        </Grid>
      )}
    </>
  );
}
